import { useState } from "react";
import { ChevronDown } from "lucide-react";

const FAQS = [
  {
    q: "Is AKTUA free?",
    a: "Yes. Workout logging, programs, nutrition, water, fiber, bodyweight, goals, 30 curated recipes and core history stay free. Pro is an optional layer for broader recipe discovery, planning and deeper interpretation.",
  },
  {
    q: "Do I need an account to start?",
    a: "No. You can complete onboarding and use the core app as a guest. Link an account later when you want cloud continuity without abandoning your guest progress.",
  },
  {
    q: "Can I build my own food and training setup?",
    a: "Yes. Create custom foods and recipes, save meals and favorites, build or edit workout programs, and start empty workouts whenever you prefer to choose exercises as you go.",
  },
  {
    q: "What is included in Recipes?",
    a: "Free includes 30 complete recipes: ten high-protein, ten vegetarian and ten screened for visible references to nine common allergens. Always verify ingredients and product labels for your needs. Pro adds search across 19,000+ FatSecret recipes.",
  },
  {
    q: "What does AKTUA Pro add?",
    a: "Pro adds Adaptive Weekly Planning, the wider FatSecret recipe catalog, Training Intelligence, Advanced Progress Trends, Adaptive Nutrition and Progress Drivers. Premium reports remain planned.",
  },
  {
    q: "Where can I get AKTUA?",
    a: "Android closed testing and iOS TestFlight testing are underway. Join the release-update list for wider Google Play and App Store availability.",
  },
  {
    q: "Is AKTUA medical advice?",
    a: "No. AKTUA is a fitness tracking and guidance tool, not a medical device or a substitute for professional medical advice, diagnosis or treatment.",
  },
];

const Item = ({ q, a, index }) => {
  const [open, setOpen] = useState(index === 0);
  return (
    <div className="border-b border-[#D8D1C5]">
      <button
        data-testid={`faq-question-${index}`}
        aria-expanded={open}
        aria-controls={`faq-answer-${index}`}
        onClick={() => setOpen(!open)}
        className="flex min-h-[64px] w-full items-center justify-between gap-4 py-5 text-left"
      >
        <span className="text-base font-bold text-[#202622]">{q}</span>
        <ChevronDown size={20} className={`shrink-0 text-[#2F7555] transition-transform duration-300 ${open ? "rotate-180" : ""}`} aria-hidden="true" />
      </button>
      <div id={`faq-answer-${index}`} hidden={!open} data-testid={`faq-answer-${index}`}>
        <p className="max-w-3xl pb-6 text-sm leading-relaxed text-[#65706A]">{a}</p>
      </div>
    </div>
  );
};

export const Faq = () => (
  <section id="faq" className="scroll-mt-20 py-20 lg:py-28">
    <div className="mx-auto max-w-4xl px-5 sm:px-8">
      <div className="reveal">
        <p className="eyebrow text-[#2F7555]">FAQ</p>
        <h2 className="section-title mt-3 text-4xl text-[#202622] sm:text-5xl">The useful questions.</h2>
      </div>
      <div className="reveal mt-10 border-t border-[#D8D1C5]" data-testid="faq-list">
        {FAQS.map((faq, index) => <Item key={faq.q} {...faq} index={index} />)}
      </div>
    </div>
  </section>
);
